import React, {Component} from 'react'
import {BrowserRouter, Redirect, Route, Switch} from 'react-router-dom'
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'
import Console from './components/Console'
import ExcelSearch from './components/ExcelSearch'
import Reports from './components/Reports'
import TransactionMonitoring from './components/TransactionMonitoring'
import CustomerProfile from './components/CustomerProfile'
import AuthService from './services/auth.service'
import CommonService from "./services/common.service";
import ReportService from "./services/report.service";
import {UserAction} from "./actions/UserAction"
import Account from './components/Account'
import GuardedRoute from './components/GuardedRoute'
import ApiDoc from './components/ApiDoc'
import Login from './components/Login'
import Contact from './components/Contact'
import Error from './components/Error'
import {message} from "antd"
import Header from "./components/Header";
import Footer from "./components/Footer";
import {CHANGE_LANG, initGA, izNotBlank, mainPage} from "./constants";
import i18n from "i18next";
import {CommonAction} from "./actions/CommonAction";
import MetaTags from 'react-meta-tags'
import TXPaytest from './components/TXPaytestComponents/TXPaytest'

export class App extends Component {

    checkParams() {

        const queryParams = new URLSearchParams(window.location.search)

        if (queryParams && queryParams.has("searchId")) {
            const searchId = queryParams.get("searchId") !== null ? queryParams.get("searchId") : "";
            if (searchId && searchId !== "") {
                queryParams.delete("searchId");
                window.history.replaceState(null, null, window.location.pathname);
                ReportService.saveSearchId(searchId);
            }
        }

        if (queryParams && queryParams.has("lang")) {
            const lang = queryParams.get("lang") !== null ? queryParams.get("lang") : "";
            if (lang && lang !== "") {
                queryParams.delete("lang")
                window.history.replaceState(null, null, window.location.pathname);

                if (this.props.common.lang !== lang) {
                    CommonService.saveLang(lang)
                    i18n.changeLanguage(lang)
                    this.props.commonAction(CHANGE_LANG, lang)
                }
            }
        }
    }

    getNextPage(isAuthenticated) {

        if (isAuthenticated === true) {

            if (window.location && window.location.pathname && window.location.pathname.includes("reports")) {
                return "reports"
            }

            const searchId = ReportService.getSearchId();
            if (izNotBlank(searchId)) {
                ReportService.saveSearchId(searchId);
                return "reports"
            } else {
                return "console"
            }
        }

        for (const page of mainPage) {
            if (window.location && window.location.pathname && window.location.pathname.includes(page)) {
                return page
            }
        }

        return "login";
    }

    render() {

        initGA()

        this.checkParams()

        const currentUser = AuthService.getCurrentUser()
        const isAuthenticated = currentUser && currentUser.accessToken && currentUser.accessToken !== "";
        const nextPage = this.getNextPage(isAuthenticated);
        const showHeader = !mainPage.includes(nextPage);

        message.config({top: showHeader ? (window.innerWidth < 767 ? 66 : (window.innerWidth < 991 ? 149 : 99)) : 13})

        return (
            <>
                <MetaTags>
                    <meta content={i18n.t('meta_desc')} name="description"/>
                    <meta content={i18n.t('meta_keys')} name="keywords"/>
                </MetaTags>

                <BrowserRouter>
                    {showHeader && <Header/>}

                    <Switch>
                        <Route path="/login" render={props => {
                            if (nextPage === "console") {
                                return <Redirect to={'/console'}/>
                            } else if (nextPage === "reports") {
                                return <Redirect to={'/reports'}/>
                            }

                            return <Login {...props} collapseSwitch={nextPage}/>
                        }}/>

                        <Route path='/documentation' component={ApiDoc}/>
                        <GuardedRoute path='/account' component={Account} auth={isAuthenticated} hasRole={AuthService.hasRole("COMPANY_ADMIN")}/>
                        <GuardedRoute path='/contact' component={Contact} auth={isAuthenticated} hasRole={true}/>
                        <GuardedRoute path='/console' component={Console} auth={isAuthenticated} hasRole={AuthService.hasRole("CONSOLE")}/>
                        <GuardedRoute path='/reports' component={Reports} auth={isAuthenticated} hasRole={AuthService.hasRole("REPORTS")}/>
                        <GuardedRoute path='/excel-search' component={ExcelSearch} auth={isAuthenticated} hasRole={AuthService.hasRole("EXCEL_SEARCH")}/>
                        <GuardedRoute path='/transaction-monitoring' component={TransactionMonitoring} auth={isAuthenticated}
                                      hasRole={AuthService.hasRole("TM")}/>
                        <GuardedRoute path='/customer-profile' component={CustomerProfile} auth={isAuthenticated} hasRole={AuthService.hasRole("TM")}/>
                        <GuardedRoute path='/tx-paytest' component={TXPaytest} auth={isAuthenticated} hasRole={AuthService.hasRole("TM_SIMULATE")}/>
                        <GuardedRoute path='/not-found' component={Error} auth={isAuthenticated} hasRole={true}/>
                        <Redirect to={'/console'}/>
                    </Switch>

                    {showHeader && <Footer/>}
                </BrowserRouter>
            </>
        )
    }

}

function mapStateToProps(state) {
    return {
        user: state.user,
        common: state.common,
        menu: state.menu
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        userAction: UserAction,
        commonAction: CommonAction
    }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(App);

